// Password rule (operator 2026-10-12, after the 2026-10-11 break-in via a guessed
// admin password). Mirror of the backend lib — keep the two in step: the server
// is the enforcer, this only gives the person instant feedback before submit.
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_RULE_TEXT = 'At least 12 characters, with an uppercase letter, a lowercase letter, a number and a special character';

// A new person's first password (operator 2026-11-04): sign-in name + 123456,
// set by the server, outside the rule, replaced at the first sign-in.
export const DEFAULT_PASSWORD_SUFFIX = '123456';
export const defaultPasswordFor = (loginName) => `${String(loginName || '').trim()}${DEFAULT_PASSWORD_SUFFIX}`;

// Returns null when the password is acceptable, else the first broken rule.
export function passwordPolicyError(pw, { username } = {}) {
  const p = typeof pw === 'string' ? pw : '';
  if (/\s/.test(p)) return 'Password must not contain spaces';
  if (p.length < PASSWORD_MIN_LENGTH) return `Password must be at least ${PASSWORD_MIN_LENGTH} characters`;
  if (!/[A-Z]/.test(p)) return 'Password must include an uppercase letter';
  if (!/[a-z]/.test(p)) return 'Password must include a lowercase letter';
  if (!/[0-9]/.test(p)) return 'Password must include a number';
  if (!/[^A-Za-z0-9]/.test(p)) return 'Password must include a special character (for example ! @ # $ %)';
  const name = typeof username === 'string' ? username.trim().toLowerCase() : '';
  if (name && p.toLowerCase().includes(name)) return 'Password must not contain your username';
  return null;
}

// Live checklist for the password fields: one line per rule.
export function passwordChecks(pw) {
  const p = typeof pw === 'string' ? pw : '';
  return [
    { label: `At least ${PASSWORD_MIN_LENGTH} characters`, ok: p.length >= PASSWORD_MIN_LENGTH },
    { label: 'An uppercase letter (A–Z)', ok: /[A-Z]/.test(p) },
    { label: 'A lowercase letter (a–z)', ok: /[a-z]/.test(p) },
    { label: 'A number (0–9)', ok: /[0-9]/.test(p) },
    { label: 'A special character (for example ! @ # $ %)', ok: /[^A-Za-z0-9]/.test(p) },
    { label: 'No spaces', ok: !/\s/.test(p) },
  ];
}
